import lrt2TicketingSystem_0 from "../../images/projects/lrt2TicketingSystem/0.PNG";
import lrt2TicketingSystem_1 from "../../images/projects/lrt2TicketingSystem/1.PNG";
import lrt2TicketingSystem_2 from "../../images/projects/lrt2TicketingSystem/2.PNG";
import lrt2TicketingSystem_3 from "../../images/projects/lrt2TicketingSystem/3.PNG";

export default function lrt2TicketingSystemImages() {
  return [
    lrt2TicketingSystem_0,
    lrt2TicketingSystem_1,
    lrt2TicketingSystem_2,
    lrt2TicketingSystem_3,
  ];
}